export default __webpack_public_path__ + "static/media/VMS_shop_logo.316bf94b.png";